import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {cbConfigMenuComponent} from 'app/layout/components-common/config-menu-cb/config-menu-cb.component';
import {CommonModule} from '@angular/common';
import { UtilsPipeModule } from '@core/pipes/utils-pipe';

@NgModule({
  declarations: [cbConfigMenuComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatMenuModule,
    CommonModule,
    UtilsPipeModule
  ],
  exports: [cbConfigMenuComponent],
})
export class cbConfigMenuModule {}
